export default __webpack_public_path__ + "static/lcms-5f47dedcf6e8945cb7d9a49654aa0205.png";